import { parseLocale } from '../utils/locale'
import { useIntl } from 'react-intl'
import { useMemo } from 'react'

export const useLocale = () => {
  const { locale } = useIntl()

  // Transformation appliquée globalement
  const parsedLocale = useMemo(() => parseLocale(locale), [locale])

  return { locale: parsedLocale }
}
